import { gql } from '@apollo/client';

export const RESEND_ORDER_CODE = gql`
  mutation ResendOrderCodeEmail($orderId: ID!) {
    resendOrderCodeEmail(orderId: $orderId) {
      __typename
      ... on ResendEmailSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
